import { render, staticRenderFns } from "./MobileLogo.vue?vue&type=template&id=c56f3f72&scoped=true&"
import script from "./MobileLogo.vue?vue&type=script&lang=js&"
export * from "./MobileLogo.vue?vue&type=script&lang=js&"
import style0 from "./MobileLogo.vue?vue&type=style&index=0&id=c56f3f72&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56f3f72",
  null
  
)

export default component.exports